import {type Module} from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// state
const state: EnrolmentPipelineState = {
    error: null,
    loading: true,
    entries: [],
    phases: [],
    enrolments: [],
    errorMailboxes: [],
    phaseId: '',
    phaseChildId: '',
    applicationFilter: {},
};

// module
const enrolmentPipeline: Module<EnrolmentPipelineState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default enrolmentPipeline;